import { GeoView } from './geoView';
import { GeoPath } from './geoPath';
export { GeoView, GeoPath };
export const geoLibrary = {
    'composition.geoView': GeoView,
    'composition.geoPath': GeoPath,
};
//# sourceMappingURL=index.js.map